// extracted by mini-css-extract-plugin
export default {"option":"VideoSearchInput_option__z2zfl","checkedIcon":"VideoSearchInput_checkedIcon__QeuCJ"};